import React from 'react'
import DatePicker from 'react-datepicker'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import { SelectField, MenuItem, RaisedButton } from 'material-ui'

const Header = ({
  date,
  resetToToday,
  handleChange,
  handleFilterSelect,
  callLogFilter,
}) => (
  <div className={'header'}>
    <div className={'todayButton'}>
      <RaisedButton
        className={'raisedButton'}
        label="Today"
        backgroundColor={'#555555'}
        labelPosition="before"
        labelColor={'white'}
        onClick={resetToToday}
      />
    </div>
    <div className={'datePickerBox'}>
      <DatePicker
        className={'datePicker'}
        selected={date}
        onChange={handleChange}
        dateFormat="ddd, MMM DD, YYYY"
        filterDate={allowed => moment().isAfter(allowed)}
      />
    </div>
    <div className={'voicemailCheckbox'} >
      <SelectField
        id="filter"
        autoWidth
        onChange={(e, ind, val) => handleFilterSelect(val)}
        value={callLogFilter}
        style={{ width: '200px', textAlign: 'left' }}
      >
        <MenuItem value="all" primaryText="All Calls" />
        <MenuItem value="received" primaryText="Received Calls" />
        <MenuItem value="outgoing" primaryText="Outgoing Calls" />
        <MenuItem value="missed" primaryText="Missed Calls" />
        <MenuItem value="voicemails" primaryText="Voicemails" />
      </SelectField>
    </div>
  </div>
)

Header.propTypes = {
  date: PropTypes.object.isRequired,
  resetToToday: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFilterSelect: PropTypes.func.isRequired,
  callLogFilter: PropTypes.string.isRequired,
}

export default Header



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/Header.js